import { GoogleStores } from "./GoogleStores";

export const Stores = [...GoogleStores];
